import Heading from '@components/UI/Typography/Heading';
import Paragraph from '@components/UI/Typography/Paragraph';
import useMods from '@hooks/useMods';
import RenderIf from '@utils/renderIf';

import PropTypes from 'prop-types';
import React from 'react';

const BlockquoteAuthor = ({ mods, mix, author, config }) => {
    const { className } = useMods(BlockquoteAuthor, { mix, mods });

    return (
        <div className={ className }>
            <Heading tag='h4'>
                { author }
            </Heading>
            <RenderIf isTrue={!config?.withoutFrom}>
                <Paragraph>
                    from
                </Paragraph>
            </RenderIf>
        </div>
    );
};

BlockquoteAuthor.displayName = 'Blockquote__Author';

BlockquoteAuthor.propTypes = {
    author: PropTypes.string.isRequired,
    children: PropTypes.node,
    mix: PropTypes.object,
    mods: PropTypes.object
};

BlockquoteAuthor.defaultProps = {
    mix: {},
    mods: {}
};

export default BlockquoteAuthor;
